import { buildPosition } from "./msiPositionBuilder";

export function storageGet(key, fallback = []) {
  try {
    return JSON.parse(localStorage.getItem(key) || "null") ?? fallback;
  } catch {
    return fallback;
  }
}

export function storageSet(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function buildWatchlistItem(play, helpers = {}) {
  const {
    contractLabel = (x) => x.contract || "",
    fmtTarget = (x) => x.target || "",
    optionPlayScore = () => 0,
    optionPlayLabel = () => "WATCH",
    fmtStage = (x) => x.recovery_3d_stage || x.stage || x.thesis || "",
  } = helpers;

  return {
    id: `WL-${Date.now()}-${play.ticker}`,
    ticker: play.ticker,
    bias: play.bias || "WAIT",
    contract: contractLabel(play),
    play_label: optionPlayLabel(play),
    play_score: optionPlayScore(play),
    price: Number(play.price || play.lastPrice || 0),
    msi_score: Number(play.msi_score || 0),
    opportunity: Number(play.recovery_3d_expansion_room_pct || 0),
    target: fmtTarget(play.target || play.price_target || ""),
    sector: play.sector || "",
    confluence: Number(play.confidence || play.confluence_score || 0),
    structure: fmtStage(play.recovery_3d_stage || play.stage || ""),
    candle: play.pattern_alignment || play.candle_bias || "",
    thesis: play.recovery_3d_stage || play.setup_type || play.stage || "",
    notes: "",
    status: "WATCHING",
    added_at: new Date().toISOString(),
    source: "MSI_UNIVERSE",
  };
}

export function addToWatchlist(play, helpers = {}) {
  const existing = storageGet("msi_watchlist", []);
  const item = buildWatchlistItem(play, helpers);

  const exists = existing.some(
    (x) =>
      x.ticker === item.ticker &&
      x.contract === item.contract
  );

  if (exists) {
    return { added: false, item };
  }

  const next = [item, ...existing];

  storageSet("msi_watchlist", next);

  return {
    added: true,
    item,
    watchlist: next,
  };
}

export function removeFromWatchlist(item) {
  const existing = storageGet("msi_watchlist", []);

  const next = existing.filter((x) => x.id !== item.id);

  storageSet("msi_watchlist", next);

  return next;
}

export function watchlistItemToPosition(item) {
  return buildPosition({
    ticker: item.ticker,
    bias: item.bias,
    contract: item.contract,
    price: item.price,
    price_target: item.target,
    target: item.target,
    stage: item.thesis || item.structure,
    dte: item.dte || 30,
  });
}

export function moveWatchlistToPositions(items) {
  const open = storageGet("msi_open_positions", []);
  const watchlist = storageGet("msi_watchlist", []);

  let added = 0;
  let skipped = 0;

  const selectedIds = new Set(items.map((x) => x.id));

  const nextOpen = [...open];

  items.forEach((item) => {
    const position = watchlistItemToPosition(item);

    const exists = nextOpen.some(
      (p) =>
        p.ticker === position.ticker &&
        p.contract === position.contract &&
        String(p.status || "").toUpperCase() !== "CLOSED"
    );

    if (exists) {
      skipped += 1;
      return;
    }

    nextOpen.unshift(position);
    added += 1;
  });

  const nextWatchlist = watchlist.filter(
    (x) => !selectedIds.has(x.id)
  );

  storageSet("msi_open_positions", nextOpen);
  storageSet("msi_watchlist", nextWatchlist);

  return {
    added,
    skipped,
    open: nextOpen,
    watchlist: nextWatchlist,
  };
}
